// TODO: Rename this component to Overlay.tsx to better reflect its responsibilities
import * as React from 'react';
import classNames from 'classnames';

import {
  SearchSuggestionGroup,
  SearchSuggestionItem,
  SearchSuggestions,
} from '@wix/thunderbolt-components';
import { TranslationGetter } from '@wix/editor-elements-types';

import {
  OnSuggestionsFooterClickHandler,
  OnSuggestionSelectHandler,
  OnSuggestionGroupSelectHandler,
} from '../../corvid/searchBoxValuePropsSDKFactory';
import * as translations from '../i18n.constants';
import { Footer } from './footer/Footer';
import { Group } from './group/Group';
import { Item } from './item/Item';

import style from './Suggestions.scss';

type SuggestionsProps = {
  children: JSX.Element;
  onSuggestionGroupSelect: OnSuggestionGroupSelectHandler;
  onSuggestionSelect: OnSuggestionSelectHandler;
  onSuggestionsFooterClick: OnSuggestionsFooterClickHandler;
  query: string;
  shouldShowSuggestions: boolean;
  suggestions: SearchSuggestions;
  translate: TranslationGetter;
};

const getSuggestionRenderer: (
  props: SuggestionsProps,
) => (
  item: SearchSuggestionItem | SearchSuggestionGroup,
  index: number,
) => JSX.Element = ({
  onSuggestionGroupSelect,
  onSuggestionSelect,
  translate,
}) => (item, index) => {
  if (item.type === 'group') {
    return (
      <Group
        group={item}
        id={`search-suggestion-item-${index}`}
        key={index}
        onClick={onSuggestionGroupSelect}
        translate={translate}
      />
    );
  }
  return (
    <Item
      id={`search-suggestion-item-${index}`}
      item={item}
      key={index}
      onClick={onSuggestionSelect}
    />
  );
};

export const Suggestions: React.FC<SuggestionsProps> = props => {
  const {
    children,
    onSuggestionsFooterClick,
    query,
    shouldShowSuggestions,
    suggestions,
    translate,
  } = props;
  const suggestionRenderer = getSuggestionRenderer(props);

  const getFooterText = () => {
    return `${translate(
      translations.NAMESPACE,
      translations.SUGGESTION_FOOTER_SEARCH_ALL_KEY,
      translations.SUGGESTION_FOOTER_SEARCH_ALL_DEFAULT,
    )} "${query}"`;
  };

  const isSuggestionsShown = Boolean(shouldShowSuggestions && suggestions);

  return (
    <div
      className={classNames(style.overlay, {
        [style.suggestionsShown]: isSuggestionsShown,
        [style.suggestionsHidden]: !isSuggestionsShown,
      })}
    >
      <div className={style.formContainer}>{children}</div>
      {shouldShowSuggestions && suggestions && (
        <div className={style.suggestions} aria-hidden="true">
          <div className={style.suggestionList} role="listbox">
            {suggestions.items.map(suggestionRenderer)}
          </div>
          {suggestions.footer && (
            <Footer
              onSuggestionsFooterClick={onSuggestionsFooterClick}
              footerText={getFooterText()}
            />
          )}
        </div>
      )}
    </div>
  );
};
